import LoginPage from "../components/pages/Login/LoginPage.vue";
import PhoneLogin from "../components/pages/Login/PhoneLogin.vue";
import VerificationPage from "../components/pages/Login/VerificationPage.vue";

const authRoutes = [
  {
    path: "/",
    name: "loginView",
    meta: { requiresGuest: true },

    component: LoginPage,
    children: [
      { path: "/", name: "phoneLogin", component: PhoneLogin },
      { path: "/verification", name: "verificationPage", component: VerificationPage },
    ],
  },
];

export default authRoutes;